var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsSansSerif(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20230101 at Thu Jan 26 22:59:00 2023\n By Rapha\xEBl Renaudon\nCopyright lou 2017\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "MS-Sans-Serif",
    horizAdvX: 2234
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "MS Sans Serif",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 4096,
    panose1: "0 0 4 0 0 0 0 0 0 0",
    ascent: 3276,
    descent: -820,
    xHeight: 2234,
    capHeight: 3351,
    bbox: "-372 -744 4096 4099",
    underlineThickness: 204,
    underlinePosition: 103,
    unicodeRange: "U+0020-201D"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 1117,
    d: "M1675 475v533h-533v-533h533zM2208 1099v532h-1066v-532h1066zM1675 1719v532h-533v-532h533zM2208 2342v529h-533q-221 0 -375 -154q-158 -157 -158 -375h1066zM0 0v3351h3351v-3351h-3351z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 1117,
    d: "M1675 475v533h-533v-533h533zM2208 1099v532h-1066v-532h1066zM1675 1719v532h-533v-532h533zM2208 2342v529h-533q-221 0 -375 -154q-158 -157 -158 -375h1066zM0 0v3351h3351v-3351h-3351z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph1",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph2",
    horizAdvX: 744
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 744
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 744,
    d: "M0 0v372h372v-372h-372zM0 744v2607h372v-2607h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 1861,
    d: "M0 2234v1117h372v-1117h-372zM1117 2234v1117h372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 2606,
    d: "M1489 1117v1117h-745v-1117h745zM372 0v744h-372v373h372v1117h-372v372h372v745h372v-745h745v745h372v-745h373v-372h-373v-1117h373v-373h-373v-744h-372v744h-745v-744h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    d: "M0 372v372h372v-372h-372zM1489 372v745h372v-745h-372zM0 1861v745h372v-745h-372zM1489 2234v372h372v-372h-372zM744 -372v372h-372v372h372v1117h-372v372h372v745h-372v372h372v373h373v-373h372v-372h-372v-1117h372v-372h-372v-745h372v-372h-372v-372h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 2978,
    d: "M1489 0v372h745v-372h-745zM0 372v372h372v-372h-372zM1117 372v372h372v-372h-372zM2234 372v372h372v-372h-372zM372 744v373h372v-373h-372zM1489 744v373h745v-373h-745zM744 1117v372h373v-372h-373zM1117 1489v372h372v-372h-372zM1489 1861v373h372v-373h-372z M372 2234v372h745v-372h-745zM1861 2234v372h373v-372h-373zM0 2606v372h372v-372h-372zM1117 2606v372h372v-372h-372zM2234 2606v372h372v-372h-372zM372 2978v373h745v-373h-745z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    d: "M372 0v372h745v-372h-745zM1489 0v372h372v-372h-372zM1117 372v745h372v-745h-372zM0 372v1117h372v-1117h-372zM744 1117v372h373v-372h-373zM1489 1117v372h372v-372h-372zM372 1489v745h372v-745h-372zM0 2234v744h372v-744h-372zM744 2234v744h373v-744h-373z M372 2978v373h372v-373h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 744,
    d: "M0 2234v1117h372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 1117,
    d: "M372 -744v372h372v-372h-372zM0 -372v3350h372v-3350h-372zM372 2978v373h372v-373h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 1117,
    d: "M0 -744v372h372v-372h-372zM372 -372v3350h372v-3350h-372zM0 2978v373h372v-373h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 1489,
    d: "M0 1861v373h372v-373h-372zM744 1861v373h373v-373h-373zM372 2234v372h372v-372h-372zM0 2606v372h372v-372h-372zM744 2606v372h373v-372h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    d: "M744 372v745h-744v372h744v745h373v-745h744v-372h-744v-745h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 1117,
    d: "M0 -372v372h372v-372h-372zM372 0v372h372v-372h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 1117,
    d: "M0 1117v372h744v-372h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 744,
    d: "M0 0v372h372v-372h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 1861,
    d: "M0 0v744h372v-744h-372zM372 744v745h372v-745h-372zM744 1489v745h373v-745h-373zM1117 2234v1117h372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    d: "M372 0v372h1117v-372h-1117zM0 372v2606h372v-2606h-372zM1489 372v2606h372v-2606h-372zM372 2978v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 1489,
    d: "M744 0v2606h-744v372h744v373h373v-3351h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    d: "M0 0v744h372v-372h1489v-372h-1861zM372 744v373h372v-373h-372zM744 1117v372h373v-372h-373zM1117 1489v372h372v-372h-372zM0 2606v372h372v-372h-372zM1489 1861v1117h372v-1117h-372zM372 2978v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    d: "M372 0v372h1117v-372h-1117zM0 372v372h372v-372h-372zM1489 372v1117h372v-1117h-372zM744 1489v372h745v-372h-745zM0 2606v372h372v-372h-372zM1489 1861v1117h372v-1117h-372zM372 2978v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    d: "M372 1489v745h372v-745h-372zM1117 0v744h-1117v745h372v-372h745v1117h-373v744h373v373h372v-2234h372v-373h-372v-744h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    d: "M372 0v372h1117v-372h-1117zM0 372v372h372v-372h-372zM1489 372v1489h372v-1489h-372zM0 1489v1862h1861v-373h-1489v-744h1117v-373h-1117v-372h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    d: "M372 0v372h1117v-372h-1117zM1489 372v1117h372v-1117h-372zM0 372v2606h372v-1117h1117v-372h-1117v-1117h-372zM1489 2606v372h372v-372h-372zM372 2978v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    d: "M372 0v1117h372v-1117h-372zM744 1117v744h373v-744h-373zM1117 1861v745h372v-745h-372zM1489 2606v372h-1489v373h1861v-745h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    d: "M372 0v372h1117v-372h-1117zM0 372v1117h372v-1117h-372zM1489 372v1117h372v-1117h-372zM372 1489v372h1117v-372h-1117zM0 1861v1117h372v-1117h-372zM1489 1861v1117h372v-1117h-372zM372 2978v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    d: "M372 0v372h1117v-372h-1117zM0 372v372h372v-372h-372zM0 1861v1117h372v-1117h-372zM1489 372v1117h-1117v372h1117v1117h372v-2606h-372zM372 2978v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 744,
    d: "M0 0v372h372v-372h-372zM0 1861v373h372v-373h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 1117,
    d: "M0 -372v372h372v-372h-372zM372 0v372h372v-372h-372zM372 1861v373h372v-373h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    d: "M0 744v373h1861v-373h-1861zM0 1489v372h1861v-372h-1861z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    d: "M744 0v372h373v-372h-373zM744 744v745h373v-745h-373zM1117 1489v372h372v-372h-372zM0 2606v372h372v-372h-372zM1489 1861v1117h372v-1117h-372zM372 2978v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 4095,
    d: "M1117 -372v372h1861v-372h-1861zM372 0v744h372v-372h373v-372h-745zM1489 744v373h745v-373h-745zM1117 1117v744h372v-744h-372zM0 744v1490h372v-1490h-372zM2234 1117v744h-745v373h1117v-1117h-372zM2606 744v373h745v1117h372v-1490h-1117zM372 2234v744h745v-372 h-373v-372h-372zM2978 2234v372h-372v372h745v-744h-373zM1117 2978v373h1489v-373h-1489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 2978,
    d: "M0 0v744h372v-744h-372zM2234 0v744h372v-744h-372zM372 744v1117h372v-744h1117v744h373v-1117h-1862zM744 1861v745h373v-745h-373zM1489 1861v745h372v-745h-372zM1117 2606v745h372v-745h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    d: "M1489 372v1117h372v-1117h-372zM1489 1861v1117h372v-1117h-372zM0 0v3351h1489v-373h-1117v-1117h1117v-372h-1117v-1117h1117v-372h-1489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 2606,
    d: "M372 0v372h1489v-372h-1489zM1861 372v372h373v-372h-373zM0 372v2606h372v-2606h-372zM1861 2606v372h373v-372h-373zM372 2978v373h1489v-373h-1489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 2606,
    d: "M1489 372v372h372v-372h-372zM1861 744v1862h373v-1862h-373zM1489 2606v372h372v-372h-372zM0 0v3351h1489v-373h-1117v-2606h1117v-372h-1489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    d: "M0 0v3351h1861v-373h-1489v-1117h1117v-372h-1117v-1117h1489v-372h-1861z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    d: "M0 0v3351h1861v-373h-1489v-1117h1117v-372h-1117v-1489h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 2606,
    d: "M372 0v372h1117v-372h-1117zM1861 0v372h-372v372h372v745h-744v372h1117v-1861h-373zM0 372v2606h372v-2606h-372zM1861 2606v372h373v-372h-373zM372 2978v373h1489v-373h-1489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 2606,
    d: "M0 0v3351h372v-1490h1489v1490h373v-3351h-373v1489h-1489v-1489h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 744,
    d: "M0 0v3351h372v-3351h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 1861,
    d: "M372 0v372h745v-372h-745zM0 372v745h372v-745h-372zM1117 372v2979h372v-2979h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 2606,
    d: "M1861 0v372h373v-372h-373zM1489 372v372h372v-372h-372zM1117 744v373h372v-373h-372zM744 1117v372h373v-372h-373zM744 2234v372h373v-372h-373zM1117 2606v372h372v-372h-372zM0 0v3351h372v-1117h372v-745h-372v-1489h-372zM1489 2978v373h372v-373h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    d: "M0 0v3351h372v-2979h1489v-372h-1861z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 2978,
    d: "M1117 372v745h372v-745h-372zM744 1117v744h373v-744h-373zM1489 1117v744h372v-744h-372zM0 0v3351h372v-745h372v-745h-372v-1861h-372zM2234 0v1861h-373v745h373v745h372v-3351h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 2606,
    d: "M1117 1117v372h372v-372h-372zM744 1489v745h373v-745h-373zM0 0v3351h372v-373h372v-744h-372v-2234h-372zM1861 0v372h-372v745h372v2234h373v-3351h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 2606,
    d: "M372 0v372h1489v-372h-1489zM0 372v2606h372v-2606h-372zM1861 372v2606h373v-2606h-373zM372 2978v373h1489v-373h-1489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 2606,
    d: "M1861 1861v1117h373v-1117h-373zM0 0v3351h1861v-373h-1489v-1117h1489v-372h-1489v-1489h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 2606,
    d: "M1861 -372v372h373v-372h-373zM1117 744v373h372v-373h-372zM0 372v2606h372v-2606h-372zM372 0v372h1117v372h372v2234h373v-2606h-373v-372h-1489zM372 2978v373h1489v-373h-1489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 2606,
    d: "M1861 0v1489h373v-1489h-373zM1861 1861v1117h373v-1117h-373zM0 0v3351h1861v-373h-1489v-1117h1489v-372h-1489v-1489h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    d: "M372 0v372h1117v-372h-1117zM0 372v372h372v-372h-372zM1489 372v1117h372v-1117h-372zM372 1489v372h1117v-372h-1117zM0 1861v1117h372v-1117h-372zM1489 2606v372h372v-372h-372zM372 2978v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    d: "M744 0v2978h-744v373h1861v-373h-744v-2978h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 2606,
    d: "M372 0v372h1489v-372h-1489zM0 372v2979h372v-2979h-372zM1861 372v2979h373v-2979h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 2978,
    d: "M1117 0v744h372v-744h-372zM744 744v745h373v-745h-373zM1489 744v745h372v-745h-372zM372 1489v1117h372v-1117h-372zM1861 1489v1117h373v-1117h-373zM0 2606v745h372v-745h-372zM2234 2606v745h372v-745h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 4468,
    d: "M1117 0v744h372v-744h-372zM2606 0v744h372v-744h-372zM744 744v745h373v-745h-373zM1489 744v745h372v-745h-372zM2234 744v745h372v-745h-372zM2978 744v745h373v-745h-373zM372 1489v1117h372v-1117h-372zM1861 1489v1117h373v-1117h-373zM3351 1489v1117h372v-1117 h-372zM0 2606v745h372v-745h-372zM3723 2606v745h373v-745h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 2978,
    d: "M0 0v744h372v-744h-372zM2234 0v744h372v-744h-372zM372 744v373h372v-373h-372zM1861 744v373h373v-373h-373zM744 1117v372h373v-372h-373zM1489 1117v372h372v-372h-372zM1117 1489v372h372v-372h-372zM744 1861v373h373v-373h-373zM1489 1861v373h372v-373h-372z M372 2234v372h372v-372h-372zM1861 2234v372h373v-372h-373zM0 2606v745h372v-745h-372zM2234 2606v745h372v-745h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 2978,
    d: "M1117 0v1861h372v-1861h-372zM744 1861v373h373v-373h-373zM1489 1861v373h372v-373h-372zM372 2234v372h372v-372h-372zM1861 2234v372h373v-372h-373zM0 2606v745h372v-745h-372zM2234 2606v745h372v-745h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 2978,
    d: "M0 0v744h372v-372h2234v-372h-2606zM372 744v373h372v-373h-372zM744 1117v372h373v-372h-373zM1117 1489v372h372v-372h-372zM1489 1861v373h372v-373h-372zM1861 2234v372h373v-372h-373zM2234 2606v372h-2234v373h2606v-745h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 1117,
    d: "M0 -744v4095h744v-373h-372v-3350h372v-372h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 1861,
    d: "M1117 0v744h372v-744h-372zM744 744v745h373v-745h-373zM372 1489v745h372v-745h-372zM0 2234v1117h372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 1117,
    d: "M0 -744v372h372v3350h-372v373h744v-4095h-744z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    d: "M0 2606v372h372v-372h-372zM1489 2606v372h372v-372h-372zM372 2978v373h372v-373h-372zM1117 2978v373h372v-373h-372zM744 3351v372h373v-372h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 2606,
    d: "M0 -372v372h2234v-372h-2234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    d: "M0 372v745h372v-745h-372zM372 0v372h1117v745h-1117v372h1117v372h372v-1861h-1489zM372 1861v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    d: "M1489 372v1489h372v-1489h-372zM0 0v3351h372v-1117h1117v-373h-1117v-1489h1117v-372h-1489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    d: "M372 0v372h1117v-372h-1117zM1489 372v372h372v-372h-372zM0 372v1489h372v-1489h-372zM1489 1489v372h372v-372h-372zM372 1861v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    d: "M0 372v1489h372v-1489h-372zM372 0v372h1117v1489h-1117v373h1117v1117h372v-3351h-1489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    d: "M372 0v372h1117v-372h-1117zM1489 372v372h372v-372h-372zM0 372v1489h372v-372h1117v372h372v-744h-1489v-745h-372zM372 1861v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 1117,
    d: "M0 0v2978h372v-744h372v-373h-372v-1861h-372zM372 2978v373h372v-373h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    d: "M0 -744v372h1489v-372h-1489zM0 372v1489h372v-1489h-372zM1489 -372v372h-1117v372h1117v1489h-1117v373h1489v-2606h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    d: "M1489 0v1861h372v-1861h-372zM744 1861v373h745v-373h-745zM0 0v3351h372v-1490h372v-372h-372v-1489h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 744,
    d: "M0 0v2234h372v-2234h-372zM0 2978v373h372v-373h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 744,
    d: "M0 -744v2978h372v-2978h-372zM0 2978v373h372v-373h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    d: "M1489 0v372h372v-372h-372zM1117 372v372h372v-372h-372zM744 744v373h373v-373h-373zM744 1489v372h373v-372h-373zM1117 1861v373h372v-373h-372zM0 0v3351h372v-1862h372v-372h-372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 744,
    d: "M0 0v3351h372v-3351h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 2978,
    d: "M1117 0v1861h372v-1861h-372zM2234 0v1861h372v-1861h-372zM0 0v2234h1117v-373h-745v-1861h-372zM1489 1861v373h745v-373h-745z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    d: "M1489 0v1861h372v-1861h-372zM0 0v2234h372v-373h372v-372h-372v-1489h-372zM744 1861v373h745v-373h-745z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    d: "M372 0v372h1117v-372h-1117zM0 372v1489h372v-1489h-372zM1489 372v1489h372v-1489h-372zM372 1861v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    d: "M1489 372v1489h372v-1489h-372zM0 -744v2978h1489v-373h-1117v-1489h1117v-372h-1117v-744h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    d: "M0 372v1489h372v-1489h-372zM1489 -744v744h-1117v372h1117v1489h-1117v373h1489v-2978h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 1117,
    d: "M0 0v2234h744v-373h-372v-1861h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 1861,
    d: "M372 0v372h745v-372h-745zM0 372v372h372v-372h-372zM1117 372v372h372v-372h-372zM744 744v373h373v-373h-373zM372 1117v372h372v-372h-372zM0 1489v372h372v-372h-372zM1117 1489v372h372v-372h-372zM372 1861v373h745v-373h-745z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 1117,
    d: "M372 0v372h372v-372h-372zM0 372v2606h372v-744h372v-373h-372v-1489h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    d: "M372 0v372h745v-372h-745zM0 372v1862h372v-1862h-372zM1489 0v372h-372v372h372v1490h372v-2234h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    d: "M744 0v744h373v-744h-373zM372 744v745h372v-745h-372zM1117 744v745h372v-745h-372zM0 1489v745h372v-745h-372zM1489 1489v745h372v-745h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 2978,
    d: "M372 0v744h372v-744h-372zM1861 0v744h373v-744h-373zM744 744v745h373v-745h-373zM1489 744v745h372v-745h-372zM0 744v1490h372v-1490h-372zM1117 1489v745h372v-745h-372zM2234 744v1490h372v-1490h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 1861,
    d: "M0 0v744h372v-744h-372zM1117 0v744h372v-744h-372zM372 744v745h745v-745h-745zM0 1489v745h372v-745h-372zM1117 1489v745h372v-745h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 1861,
    d: "M-372 -744v372h744v-372h-744zM372 -372v1116h745v-372h-373v-744h-372zM0 744v1490h372v-1490h-372zM1117 744v1490h372v-1490h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 1861,
    d: "M0 0v744h372v-372h1117v-372h-1489zM372 744v373h372v-373h-372zM744 1117v372h373v-372h-373zM1117 1489v372h-1117v373h1489v-745h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 1489,
    d: "M744 -372v372h373v-372h-373zM372 0v1489h372v-1489h-372zM0 1489v372h372v-372h-372zM372 1861v1490h372v-1490h-372zM744 3351v372h373v-372h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 1489,
    d: "M0 -372v372h372v-372h-372zM372 0v1489h372v-1489h-372zM744 1489v372h373v-372h-373zM372 1861v1490h372v-1490h-372zM0 3351v372h372v-372h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 2606,
    d: "M0 2234v372h372v-372h-372zM1117 2234v372h744v-372h-744zM372 2606v372h745v-372h-745zM1861 2606v372h373v-372h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 744,
    d: "M0 2234v1117h372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 744,
    d: "M0 2234v1117h372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 1861,
    d: "M0 2234v1117h372v-1117h-372zM1117 2234v1117h372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 1861,
    d: "M0 2234v1117h372v-1117h-372zM1117 2234v1117h372v-1117h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 2606,
    d: "M1115 -744v372h373v-372h-373zM1115 -372zM742 -372v372h373v-372h-373zM742 0zM372 0v372h1489v-372h-1489zM1861 372v372h373v-372h-373zM0 372v2606h372v-2606h-372zM1861 2606v372h373v-372h-373zM372 2978v373h1489v-373h-1489z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    d: "M1115 3354v372h373v-372h-373zM1115 3726zM742 3726v372h373v-372h-373zM742 4098zM0 0v3351h1861v-373h-1489v-1117h1117v-372h-1117v-1117h1489v-372h-1861z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    d: "M1487 3726h-372v373h372v-373zM1115 3726zM1115 3353h-372v373h372v-373zM743 3353zM0 0v3351h1861v-373h-1489v-1117h1117v-372h-1117v-1117h1489v-372h-1861z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 2978,
    d: "M1115 3354v372h373v-372h-373zM1115 3726zM742 3726v372h373v-372h-373zM742 4098zM0 0v744h372v-744h-372zM2234 0v744h372v-744h-372zM372 744v1117h372v-744h1117v744h373v-1117h-1862zM744 1861v745h373v-745h-373zM1489 1861v745h372v-745h-372zM1117 2606v745h372 v-745h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 2978,
    d: "M1487 3726h-372v373h372v-373zM1115 3726zM1115 3353h-372v373h372v-373zM743 3353zM0 0v744h372v-744h-372zM2234 0v744h372v-744h-372zM372 744v1117h372v-744h1117v744h373v-1117h-1862zM744 1861v745h373v-745h-373zM1489 1861v745h372v-745h-372zM1117 2606v745h372 v-745h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    d: "M1486 3726zM1486 3726zM1486 3353h-372v373h372v-373zM1114 3353zM1115 3726h-372v373h372v-373zM743 3726zM743 3353h-372v373h372v-373zM371 3353zM0 0v3351h1861v-373h-1489v-1117h1117v-372h-1117v-1117h1489v-372h-1861z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 2978,
    d: "M1858 3726zM1858 3726zM1858 3353h-372v373h372v-373zM1486 3353zM1487 3726h-372v373h372v-373zM1115 3726zM1115 3353h-372v373h372v-373zM743 3353zM0 0v744h372v-744h-372zM2234 0v744h372v-744h-372zM372 744v1117h372v-744h1117v744h373v-1117h-1862zM744 1861v745 h373v-745h-373zM1489 1861v745h372v-745h-372zM1117 2606v745h372v-745h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    d: "M1115 2604v372h373v-372h-373zM1115 2976zM742 2976v372h373v-372h-373zM742 3348zM372 0v372h1117v-372h-1117zM1489 372v372h372v-372h-372zM0 372v1489h372v-372h1117v372h372v-744h-1489v-745h-372zM372 1861v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    d: "M1487 2981h-372v373h372v-373zM1115 2981zM1115 2608h-372v373h372v-373zM743 2608zM372 0v372h1117v-372h-1117zM1489 372v372h372v-372h-372zM0 372v1489h372v-372h1117v372h372v-744h-1489v-745h-372zM372 1861v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    d: "M1486 2981zM1486 2981zM1486 2608h-372v373h372v-373zM1114 2608zM1115 2981h-372v373h372v-373zM743 2981zM743 2608h-372v373h372v-373zM371 2608zM372 0v372h1117v-372h-1117zM1489 372v372h372v-372h-372zM0 372v1489h372v-372h1117v372h372v-744h-1489v-745h-372z M372 1861v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    d: "M1486 2976zM1486 2976zM1486 2603h-372v373h372v-373zM1114 2603zM743 2603h-372v373h372v-373zM371 2603zM372 0v372h1117v-372h-1117zM1489 372v372h372v-372h-372zM0 372v1489h372v-372h1117v372h372v-744h-1489v-745h-372zM372 1861v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    d: "M1486 3726zM1486 3726zM1486 3353h-372v373h372v-373zM1114 3353zM743 3353h-372v373h372v-373zM371 3353zM0 0v3351h1861v-373h-1489v-1117h1117v-372h-1117v-1117h1489v-372h-1861z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    d: "M1115 -744v372h373v-372h-373zM1115 -372zM742 -372v372h373v-372h-373zM742 0zM372 0v372h1117v-372h-1117zM1489 372v372h372v-372h-372zM0 372v1489h372v-1489h-372zM1489 1489v372h372v-372h-372zM372 1861v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    d: "M1115 2604v372h373v-372h-373zM1115 2976zM742 2976v372h373v-372h-373zM742 3348zM0 372v745h372v-745h-372zM372 0v372h1117v745h-1117v372h1117v372h372v-1861h-1489zM372 1861v373h1117v-373h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    d: "M1488 4v372h378v-372h-378zM1866 376v372h372v-372h-372zM1116 376v1489h372v-372h378v372h372v-744h-750v-745h-372zM1488 1865v373h378v-373h-378zM372 0v372l371 4v-372zM0 372v1489h372v-1489h-372zM743 376v1489h372v-1489h-372zM372 1861v373l371 4v-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 3270,
    d: "M2864.2 242.75zM2455 242.75v409.2h815.65v-409.2h-815.65zM409.55 242.75zM0.349609 242.75v409.2h815.65v-409.2h-815.65zM2864.2 2699.05zM2455 2699.05v409.2h815.65v-409.2h-815.65zM409.55 2697.95zM0.349609 2697.95v409.2h815.65v-409.2h-815.65zM409.55 650.85 v410.301h810.15v-410.301h-810.15zM2047.45 650.85v410.301h819.5v-410.301h-819.5zM818.75 1061.15v409.199h1229.8v-409.199h-1229.8zM2047.45 1061.15v409.199h409.2v-409.199h-409.2zM1229.05 1470.35v409.2h818.4v-409.2h-818.4zM818.75 1879.55v410.3h1229.8v-410.3 h-1229.8zM2047.45 1879.55v410.3h409.2v-410.3h-409.2zM409.55 2289.85v409.2h815.65v-409.2h-815.65zM2046.9 2289.85v409.2h820.05v-409.2h-820.05z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    d: "M1486 2981zM1486 2981zM1486 2608h-372v373h372v-373zM1114 2608zM1115 2981h-372v373h372v-373zM743 2981zM743 2608h-372v373h372v-373zM371 2608zM372 0v372h1117v-372h-1117zM0 372v1489h372v-1489h-372zM1489 372v1489h372v-1489h-372zM372 1861v373h1117v-373 h-1117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    d: "M1486 2981zM1486 2981zM1486 2608h-372v373h372v-373zM1114 2608zM1115 2981h-372v373h372v-373zM743 2981zM743 2608h-372v373h372v-373zM371 2608zM0 372v745h372v-745h-372zM372 0v372h1117v745h-1117v372h1117v372h372v-1861h-1489zM372 1861v373h1117v-373h-1117z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    d: "M372 0v372h745v-372h-745zM0 372v1862h372v-1862h-372zM1489 0v372h-372v372h372v1490h372v-2234h-372zM1486 2981zM1486 2981zM1486 2608h-372v373h372v-373zM1114 2608zM1115 2981h-372v373h372v-373zM743 2981zM743 2608h-372v373h372v-373zM371 2608z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsSansSerif);
export default __webpack_public_path__ + "static/media/MS-Sans-Serif.8f5265572ed50922cb5cee5091305d0b.svg";
export { ForwardRef as ReactComponent };